
export namespace MonitoredSegment {
  export type Item = {
    productSegmentId: number;
    productSegmentName: string;
  }
  export type Response = {
    segmentList: Item[];
  }
};

export type Details = {
  name: string;
  description: string;
  segmentIds: number[];
  subscriptions: string[];
};

export namespace CreateEditAlertDetails {
  export type Request = {
    alertId?: number;
    alertName: string;
    alertDescription: string;
    alertCriteriaId?: number[];
    segmentId: number[];
    uiSubscription?: string;
    emailSubscription: string;
  };

  export type Response = {
    responseHeader: {
      statusCode: string;
      statusMessage: string;
      id: number;
    };
  };
}

export type AlertItem = {
  alertId: number;
  clientId: number;
  alertName: string;
  segmentId: number[];
  uiSubscription: string | null;
  emailSubscription: string;
  alertDescription: string;
  updateTimestamp: string | null;
  insertTimestamp: string | null;
  alertCriteriaId?: number[];
  createdBy: string | null;
  executionStatus: string;
  completeTimestamp: string;
};

export namespace AlertList {
  export type Request = {
    alertName?: string;
    size: number;
    offset: number;
    sortingOrder: string;
    sortingColumn: string;
    associated: boolean;
    segmentId: string;
  };

  export type Response = {
    alertList: AlertItem[];
    size: string;
    offset: string;
    sortingcolumn: string;
    sortingorder: string;
    totalRecords: string;
  };
}
